import * as React from 'react';

import './FullScreenLoader.scss';

import LoaderCircle from 'common/components/core/LoaderCircle/LoaderCircle';

interface LoaderProps {
  visible?: boolean;
}

/**
 * The Nutanix Frame preloader.
 */
export default class FullScreenLoader extends React.PureComponent<LoaderProps> {
  render() {
    return (
      <div className={this.props.visible ? undefined : 'hidden'}>
        <div className="background-wrapper" />
        <div className="loading-wrapper">
          <div className="loading-box">
            <LoaderCircle />
          </div>
        </div>
      </div>
    );
  }
}
